<template>
  <h1>sadasd</h1>

</template>

<script>

import axios from "@/plugins/axios.js";
import store from "@/store";

export default {
  name: "CheckLogin",
  data() {
    return {
      apiUrl: store.getters.baseUrl,
      apiBaseUrl: window.appConfig.API_URL_BASE,
      admin: false,
      headers: {
        'Accept': 'Application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }
  },
  methods:{
    settoken(token) {
    localStorage.setItem('token',token)
    },
    getUserInfo(token) {
      let url = this.apiBaseUrl + 'api/users/get-user'
      this.headers['Authorization'] = 'Bearer ' + token
      axios.get(url,
          {headers: this.headers}).then(res => {
        delete res.data.data.username
        let data = JSON.stringify(res.data)
        localStorage.setItem('userInfo', data)
        this.$store.dispatch('updateUserData', data);
        this.settoken(token)
        this.$router.push('/')

      }).catch(err =>{
        if (err?.response?.status === 401) {
          this.logout()
        }

      })
    },
    getTokenUrl(){
      const urlParams = new URLSearchParams(window.location.search);
      let token = urlParams.get('token')

      if( token !== undefined && token !== null){
        this.getUserInfo(token)
      }else{
        this.$router.push('/auth/login')
      }
    },
    logout() {
      this.removeToken()
      this.$router.push('/auth/login')
      store.commit('setMobile', '')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('panelRole')
      localStorage.removeItem('panel-role')


    },
    removeToken() {
      localStorage.removeItem('token');
    },
  },
  mounted() {
    this.getTokenUrl()

  }
}
</script>

<style scoped>

</style>
